"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupBox = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var __1 = require("../../");
var Buttons_1 = require("../../Buttons");
var InfoMessage_1 = require("../../Indicators/InfoMessage");
var Localization_1 = require("../../Localization");
var Theme_1 = require("../../Theme");
var Group = styled_components_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    border-radius: 3px;\n    background-color: white;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n"], ["\n    border: 1px solid ", ";\n    border-radius: 3px;\n    background-color: white;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n"])), Theme_1.Color.Grey.G30);
var Header = styled_components_1.default.header(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: 25px;\n    padding: 12.5px ", ";\n    border-radius: 3px 3px 0 0;\n    color: ", ";\n    background-color: white;\n    display:flex;\n    flex-grow: 0;\n    flex-shrink: 0;\n"], ["\n    font-size: ", ";\n    line-height: 25px;\n    padding: 12.5px ", ";\n    border-radius: 3px 3px 0 0;\n    color: ", ";\n    background-color: white;\n    display:flex;\n    flex-grow: 0;\n    flex-shrink: 0;\n"])), Theme_1.FontSize, Theme_1.PixelUnit(1), Theme_1.Color.Grey.G80);
var HeaderCaption = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex: 1 1 auto;\n"], ["\n    display: flex;\n    align-items: center;\n    flex: 1 1 auto;\n"])));
var HeaderButton = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: #8990A0;\n"], ["\n    color: #8990A0;\n"])));
var Contents = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position:relative;\n    flex: 1 1 auto;\n"], ["\n    position:relative;\n    flex: 1 1 auto;\n"])));
var InfoWrapper = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display:inline-block;\n    margin-left: 20px;\n"], ["\n    display:inline-block;\n    margin-left: 20px;\n"])));
var GroupBox = /** @class */ (function (_super) {
    __extends(GroupBox, _super);
    function GroupBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderHeader = function () {
            if (_this.props.HeaderCaption) {
                return (React.createElement(Header, null,
                    React.createElement(HeaderCaption, null,
                        React.createElement("span", null, _this.props.HeaderCaption),
                        _this.props.InfoMessage ? React.createElement(InfoWrapper, null,
                            React.createElement(InfoMessage_1.InfoMessage, __assign({}, _this.props.InfoMessage))) : null),
                    _this.props.ButtonCaption && _this.props.OnButtonClickEvent ? React.createElement(Buttons_1.SecondaryButton, { OnClick: _this.props.OnButtonClickEvent, Caption: _this.props.ButtonCaption, Disabled: false }) : null,
                    _this.props.HeaderButtonOptions ? React.createElement(HeaderButton, null,
                        React.createElement(__1.OptionsButton, { Title: Localization_1.strings.Label_MoreOptions, AriaLabel: Localization_1.strings.Label_MoreOptions, Height: "20px", Width: "20px", Placement: "bottom-start" }, _this.props.HeaderButtonOptions)) : null));
            }
            return null;
        };
        return _this;
    }
    GroupBox.prototype.render = function () {
        return (React.createElement(Group, null,
            this.renderHeader(),
            React.createElement(Contents, null, this.props.children)));
    };
    return GroupBox;
}(React.PureComponent));
exports.GroupBox = GroupBox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
